﻿import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import { IHotEditableFormParentVue } from "../../common";
import common = require("../../common");
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");
import utilities = require("../utilities");
import context = require("../context");

@Component
class EditVue extends Vue implements IHotEditableFormParentVue {
    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;
    culture?: common.Cultures;
    isVisibleToggleButton = false;
    forceUpdate = '1';
    initTrigger = '';
    bag = {};
    _bagTmp: {};
    _isInit = false;
    _lastBagTimemoutId = null as NodeJS.Timeout;
    _initialConcurrencySumCheck: string;
    _manageButtonsOnFormModeChange: boolean;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        const initialConcurrencySumCheck = (this as any).$initialData.concurrencySumCheck as string || null;
        const includesConcurrencySumCheck = (this as any).$initialData.includesConcurrencySumCheck as boolean || !!initialConcurrencySumCheck;
        this._initialConcurrencySumCheck = initialConcurrencySumCheck;

        HotEditableFormLoader.prepareComponentsMarkupFromTarget(true, includesConcurrencySumCheck, rootId).loadComponentsFromParent(this);

        const formName = (this as any).$initialData.formName;
        this.formManager = new HotEditableFormManager(this, formName, {
            loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false,
            embeddedContentModels: (((this as any).$initialData.embeddedContentModels || []) as common.IEmbeddedContentModel[]).sort((a, b) => {
                return a.order - b.order;
            })
        });
        this.shared = new SharedHotEditableParentForm(this.formManager);
        this.culture = context.culture.get();
        this._bagTmp = (this as any).$initialData.bag || {};

        this.$options.el = '#' + rootId;
    }

    destroyComponents() {
        this.formManager.destroyComponents();
        this.formManager = null;
        return this;
    }

    created() { }

    beforeMount() {
        this.initTrigger = "1";
    }

    mounted() {
        this.bag = this._bagTmp;

        if (!!this._initialConcurrencySumCheck)
            this.initConcurrencySumCheck(this._initialConcurrencySumCheck);

        this.initTrigger = "1";
    }

    private onInit(initTrigger: string, action: () => void | string) {
        if (!initTrigger)
            return '';
        this.initTrigger = '';
        if (action)
            action();
        return action ? action() || '' : '';
    }

    updateBagOnInit(initTrigger: string, key: string, value?: any) {
        return this.onInit(initTrigger, () => {
            this.setToBag(key, value);
            return value;
        });
    }

    /** Uniquement pour les v-on:click|etc. Sinon utiliser directement : utilities.copyToClipboard(text) */
    copyToClipboard(text: string) {
        utilities.copyToClipboard(text);
        return this;
    }

    applyUpdate(actionValue?: string, actionType?: common.HotEditableActionTypes) {
        this.formManager.applyUpdate(actionValue, actionType);
        return this;
    }
    updateFieldTextualValue(fieldName: string, value?: string | ((oldValue?: string) => string)) {
        value = value || '';
        if (!fieldName)
            throw "L'argument 'fieldName' est requis.";
        const f = this.formManager.getFieldByName(fieldName);
        if (f) {
            const v = typeof value === "string" ? value : value(f.getTextualValue());
            f.setFromTextualValue(v);
        }
        return this;
    }
    getBagRaw() {      
        const r = utilities.serializeBag(this.bag || {});
        return r;
    }
    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }

    setToBag(key: string, value?: any, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        delayMs = delayMs || 0;
        forceDelayedSetToBeExecuted = forceDelayedSetToBeExecuted === true;
        const f = () => { this.$set(this.bag, key, value || value === false || value === 0 || value === '' ? value : ''); }
        if (!forceDelayedSetToBeExecuted && this._lastBagTimemoutId) {
            clearTimeout(this._lastBagTimemoutId);
            this._lastBagTimemoutId = null;
        }
        if (delayMs)
            this._lastBagTimemoutId = setTimeout(f, Math.max(0, Math.min(15000, delayMs)));
        else
            f();
        return this;
    }
    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }
    setBooleanToBag(key: string, value: boolean, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, value === true, delayMs, forceDelayedSetToBeExecuted);
        return this;
    }
    toggleBagBoolean(key: string, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, !this.getBooleanFromBag(key), delayMs, forceDelayedSetToBeExecuted);
        return this;
    }
    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }

    updateBag(updated: common.IBag) {
        if (!updated)
            return this;
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = updated.raw[k];
                if (!isUpdated)
                    isUpdated = true;
            }
        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
    setManageButtonsOnFormModeChange(value: boolean) {
        this._manageButtonsOnFormModeChange = value !== false;
        return this;
    }
    manageButtonsOnFormModeChange() {
        return this._manageButtonsOnFormModeChange !== false;
    }
    private initConcurrencySumCheck(sumCheck?: string) {
        const f = this.formManager.getFieldByName("ConcurrencySumCheck");
        if (f)
            f.setFromTextualValue(sumCheck || '');
        return this;
    }
    // setActionConfirmation(key: string, action?: () => void) {
    //     if (!key)
    //         throw "L'argument 'key' est NULL.";

    //     const f = this.formManager.getFieldByName(key);

    //     if (f) {
    //         // Le champ existe en mode hoteditable (ancienne facon de faire)
    //         f.setFromTextualValue("true");
    //     } else {
    //         const name = this.formManager.getFormName();
    //         const form = document.getElementsByName(name)[0];
    //         const input = document.createElement("input") as HTMLInputElement;
    //         input.setAttribute("type", "hidden");
    //         input.value = "true";
    //         form.appendChild(input);
    //     }

    //     if (action)
    //         this.$nextTick(action);

    //     return this;
    // }
    refreshEmbeddedComponents(urlParameters?: {}) {
        this.formManager.refreshEmbeddedComponents(urlParameters);
    }
    refreshBrotherEmbeddedComponents() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.refreshBrotherEmbeddedComponents(name);
        return this;
    }
    restoreBrotherEmbeddedComponents() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.restoreBrotherEmbeddedComponents(name);
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.ensureBrotherEmbeddedComponentsIsDefaultUrl(name);
        return this;
    }
    refreshForceUpdate() {
        this.forceUpdate = utilities.createGuid("N");
    }
}

export = EditVue;